/**
 * Badge de PESO de uma pergunta do diagnóstico ESCALA.
 *
 * O peso (1.0 / 1.5 / 2.0) já vem por pergunta do escala-engine; aqui vira um
 * selo visual com barrinhas + cor pra o usuário entender o quanto cada pergunta
 * pesa no resultado. Peso 0 = pergunta de roteamento (sem peso) → não renderiza.
 *
 *  - alto  (>= 2.0): vermelho, 3 barrinhas
 *  - médio (>= 1.5): amarelo,   2 barrinhas
 *  - baixo (>= 1.0): verde,     1 barrinha
 */

type Tier = { label: string; color: string; bars: 1 | 2 | 3 };

function tierForWeight(weight: number): Tier | null {
  if (weight >= 2) return { label: "Peso alto", color: "#d92d4a", bars: 3 };
  if (weight >= 1.5) return { label: "Peso médio", color: "#e0a022", bars: 2 };
  if (weight >= 1) return { label: "Peso baixo", color: "#2faa5a", bars: 1 };
  return null;
}

export function EscalaWeightBadge({ weight }: { weight: number }) {
  const tier = tierForWeight(weight);
  if (!tier) return null;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        marginLeft: 8,
        color: tier.color,
      }}
    >
      <span
        aria-hidden
        style={{ display: "inline-flex", alignItems: "flex-end", gap: 2, height: 11 }}
      >
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            style={{
              width: 3,
              height: 4 + i * 3.5,
              borderRadius: 1,
              background: i < tier.bars ? tier.color : "var(--wf-ink-5)",
            }}
          />
        ))}
      </span>
      {tier.label}
    </span>
  );
}
